'use client';
import { useSubscribedDraw } from '../hooks/useSubscribedDraw.js';
import { useSubscribedDrawForecast } from '../hooks/useSubscribedDrawForecast.js';
/**
 * SubscribedDrawContainer.tsx.
 *
 * @param root0 SubscribedDrawContainerProps
 * @param root0.product The product for which to get the subscribed draw forecast.
 * @param root0.drawNumber The draw number to get the subscribed draw forecast for.
 * @param root0.subscriptionType subscription detail level
 * @returns undefined
 */
export function SubscribedDrawContainer({ product, drawNumber, subscriptionType, }) {
    const shouldSkipForecast = subscriptionType !== 'FORECAST' && subscriptionType !== 'FULL';
    const shouldSkipDraw = subscriptionType !== 'DRAW' && subscriptionType !== 'FULL';
    useSubscribedDrawForecast({ product, drawNumber }, { skip: shouldSkipForecast });
    useSubscribedDraw({ product, drawNumber }, { skip: shouldSkipDraw });
    return undefined;
}
//# sourceMappingURL=SubscribedDrawContainer.js.map